export default (mediationData, isDiscontinuation) => {

  const m = {
    mediationData,
    isDiscontinuation
  }
  const init = () => {
    console.log('buildMediation', m);

    const playerListUl = document.querySelector('.le-meditation-list__body');

    // 選手データの流し込み
    if (m.mediationData) {
      playerListUl.innerHTML = m.mediationData;
    }

    // オーバーレイの表示の有無
    if (m.isDiscontinuation) {
      playerListUl.classList.add('is-discontinuation');
      playerListUl.dataset.content = '中止';
    } else if (m.mediationData == '') {
      playerListUl.classList.add('is-coming');
    }

    playerListUl.classList.remove('_skelton');
    playerListUl.removeAttribute('aria-hidden');
  }

  init()
}
